import {
  IGetGigsScheduleParams,
  IGetPrintScheduleParams,
  IScheduleGigDay,
} from '@network/models/gig-schedule.model'
import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'

export class GigsScheduleApi {
  constructor(private axios: AxiosService) {}

  getGigsSchedule = async (params: IGetGigsScheduleParams) => {
    const response = await this.axios.get<IPayload<IScheduleGigDay[]>>(
      Endpoints.getGigsSchedule,
      params,
    )
    return response
  }

  postPrintSchedule = async (params: IGetPrintScheduleParams) => {
    const response = await this.axios.post<Blob>(
      Endpoints.postPrintSchedule,
      params,
      {
        responseType: 'blob',
      },
    )
    return response
  }
}
